const BASE_URL: string = process.env.REACT_APP_API_KEY || '';
// const BASE_URL: string = 'http://178.128.61.122:8093';

export const FIND_MANY_COUPON = BASE_URL + '/coupon/findMany';
export const FIND_MANY_COUPON_HISTORY = BASE_URL + '/couponLog/findMany'
export const CREATE_COUPON = BASE_URL + '/coupon/create';
export const UPDATE_COUPON = BASE_URL + '/coupon/update?Id=';
export const DELETE_COUPON = BASE_URL + '/coupon/delete?Id=';
